import { UI_CONSTANTS } from "@/constants/form.constants";
import { Grid } from "@talentech/components";
import React from "react";

interface LayoutWrapperProps {
  children: React.ReactNode;
}

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => {
  return (
    <Grid container fluid className="py-4" id="rollout-form">
      <Grid
        item={"true"}
        xs={12}
        className="d-flex justify-content-center align-items-center"
      >
        <div
          className="mt-4 d-flex flex-column gap-4 container"
          style={{ maxWidth: UI_CONSTANTS.MAX_FORM_WIDTH }}
        >
          {children}
        </div>
      </Grid>
    </Grid>
  );
};

export default LayoutWrapper;
